import { Box, Typography } from '@mui/material'
import _ from 'lodash'

/** COMPONENT */

import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'

/** STYLE */
import { SORT_TYPE } from 'constants/common'
import * as UseStyled from 'features/report/useStyled'
import { useTranslation } from 'react-i18next'
import { numberFormat } from 'utils/app.utils'
interface FcComponent {
    page: number
    pageLimit: number
    rowCount: number
    data: any
    handleChangeRowsPerPage: (val: any) => void
    handleChangePage: (val: any) => void
    onRequestSort: (sortBy: string, sortType: string) => void
    setSortType: (val: SORT_TYPE) => void
    setSortBy: (val: string) => void
    sortType: string
    sortBy: string
}

export default function ProfitSummaryList(props: FcComponent) {
    const { t } = useTranslation()
    const headCells = [
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.PROFIT_SUMMARY.NO', align: 'center', class: 'text-nowrap', rowSpan: 2 },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.PROFIT_SUMMARY.TREATMENT_CODE', align: 'left', class: 'text-nowrap', rowSpan: 2 },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.PROFIT_SUMMARY.TREATMENT_NAME', align: 'left', class: 'text-nowrap', rowSpan: 2 },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.PROFIT_SUMMARY.COST_PER_SESSION', align: 'center', class: 'text-nowrap', rowSpan: 2 },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.PROFIT_SUMMARY.PRICE_PER_SESSION', align: 'center', class: 'text-nowrap', rowSpan: 2 },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.PROFIT_SUMMARY.QUANTITY', align: 'center', class: 'text-nowrap', rowSpan: 2 },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.PROFIT_SUMMARY.TOTAL_COST', align: 'center', class: 'text-nowrap', rowSpan: 2 },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.PROFIT_SUMMARY.TOTAL_PAID', align: 'center', class: 'text-nowrap', rowSpan: 2 },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.PROFIT_SUMMARY.TOTAL_PAYMENT', align: 'center', class: 'text-nowrap', rowSpan: 2 },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.PROFIT_SUMMARY.TOTAL_PROFIT', align: 'center', class: 'text-nowrap', rowSpan: 2 },
        { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.PROFIT_SUMMARY.NET_PROFIT', align: 'center', class: 'text-nowrap', rowSpan: 2 }
    ]
    const onRequestSort = (sortByVal: string, sortTypeVal: SORT_TYPE) => {
        props.setSortType(sortTypeVal)
        props.setSortBy(sortByVal)
        props.handleChangePage(1)
    }

    const renderData = (data: any, no: number, render: 'data' | 'sum') => {
        const num = props.page * props.pageLimit - props.pageLimit + no + 1
        if (render === 'data') {
            const objRenderData = {
                key: num.toString(),
                id: no.toString(),
                obj: data,
                columns: [
                    { option: 'TEXT', align: 'center', label: num, class: 'text-nowrap' },
                    { option: 'TEXT', align: 'left', label: data?.operativeCode || '-' },
                    { option: 'TEXT', align: 'left', label: data?.operativeName || '-', class: 'text-nowrap' },
                    { option: 'TEXT', align: 'right', label: numberFormat(data?.costPerUnit || 0), class: 'text-nowrap' },
                    { option: 'TEXT', align: 'right', label: numberFormat(data?.listPricePerUnit || 0), class: 'text-nowrap' },
                    { option: 'TEXT', align: 'center', label: Number(data?.qty) || 0, class: 'text-nowrap' },
                    { option: 'TEXT', align: 'right', label: numberFormat(data?.totalCost || 0), class: 'text-nowrap' },
                    { option: 'TEXT', align: 'right', label: numberFormat(data?.totalListPrice || 0), class: 'text-nowrap' },
                    { option: 'TEXT', align: 'right', label: numberFormat(data?.totalPaid || 0), class: 'text-nowrap' },
                    { option: 'TEXT', align: 'right', label: numberFormat(data?.grossProfit || 0), class: 'text-nowrap' },
                    { option: 'TEXT', align: 'right', label: numberFormat(data?.netProfit || 0), class: 'text-nowrap' },
                ]
            }

            return <TableRowCommon {...objRenderData} />
        } else {
            const objRenderData = {
                key: no.toString(),
                id: no.toString(),
                obj: data,
                columns: [
                    { option: 'MERGE', align: 'center', colSpan: 2 },
                    {
                        option: 'TEXT',
                        align: 'right',
                        label: <Typography>{t('REPORT.TITLE.SUM')}</Typography>,
                        class: 'text-nowrap'
                    },
                    { option: 'TEXT', align: 'right', label: numberFormat(_.sumBy(data, 'costPerUnit') || 0), class: 'text-nowrap' },
                    { option: 'TEXT', align: 'right', label: numberFormat(_.sumBy(data, 'listPricePerUnit') || 0), class: 'text-nowrap' },
                    { option: 'TEXT', align: 'center', label: _.sumBy(data, (item: any) => Number(item.qty)), class: 'text-nowrap' },
                    { option: 'TEXT', align: 'right', label: numberFormat(_.sumBy(data, 'totalCost') || 0), class: 'text-nowrap' },
                    { option: 'TEXT', align: 'right', label: numberFormat(_.sumBy(data, 'totalListPrice') || 0), class: 'text-nowrap' },
                    { option: 'TEXT', align: 'right', label: numberFormat(_.sumBy(data, 'totalPaid') || 0), class: 'text-nowrap' },
                    { option: 'TEXT', align: 'right', label: numberFormat(_.sumBy(data, 'grossProfit') || 0), class: 'text-nowrap' },
                    { option: 'TEXT', align: 'right', label: numberFormat(_.sumBy(data, 'netProfit') || 0), class: 'text-nowrap' }
                ],
                classes: 'row-summary'
            }
            return <TableRowCommon {...objRenderData} />
        }
    }

    return <>
        <Box>
            <UseStyled.ResponsiveReportTable>
                <TableCustom
                    rowHeadCell={2}
                    tableMinWidth={992}
                    page={props.page}
                    pageLimit={props.pageLimit}
                    sortType={props.sortType}
                    sortBy={props.sortBy}
                    rowCount={props.rowCount}
                    onSort={onRequestSort}
                    setPageLimit={props.handleChangeRowsPerPage}
                    setPage={props.handleChangePage}
                    headCells={headCells}
                    rowsData={[
                        _.map(props.data, (d: any, index: number) => {
                            return renderData(d, index, 'data')
                        }),
                        renderData(props.data, 0, 'sum')
                    ]}
                    customScroll
                />
            </UseStyled.ResponsiveReportTable>
        </Box>
    </>
}